import React, { useEffect, useState } from "react";
import { Link, Outlet, useLocation } from "react-router-dom";
import { Layout, Button } from "antd";
import Logo from "@assets/images/logo.png";
import {
    DashboardLogo,
    DashboardLogoWrapper,
    HeaderOutletWrapper,
    CloseSliderContainerClosed,
    DashboardLayoutWrapper,
    SidebarContainer,
    StyledMenu,
    DashboardTitle,
    LogoTitleWrapper,
    SearchFormWrapper,
    MobileLogo,
} from "../styled";
import { MenuItems } from "../data";
import SearchForm from "@components/Input/SearchForm/SearchForm";
import Header from "../../Header/container";
import { RouterPaths } from "../../router/routerPaths";
import { ThemesColors } from "@themes/index";

const { Content } = Layout;
const DashboardLayout = () => {
    const [isCollapsed, setIsCollapsed] = useState(false);
    const [searchValue, setSearchValue] = useState("");
    const location = useLocation();
    useEffect(() => {
        if (location.pathname !== RouterPaths.ROLE) {
            localStorage.removeItem("learningKey");
            sessionStorage.removeItem("roleKey");
        }
        if (location.pathname !== RouterPaths.EMPLOYEESOVERVIEW) {
            localStorage.removeItem("employeesKey");
            sessionStorage.removeItem("employeeID");
            localStorage.removeItem("employeesSettings");
        }
        const handleResize = () => {
            const currentWidth = window.innerWidth;
            if (location.pathname === RouterPaths.LEARNINGPLANINFORMATION) {
                setIsCollapsed(true);
                return;
            }
            if (currentWidth <= 1024) {
                setIsCollapsed(true);
            }
        };
        window.addEventListener("resize", handleResize);
        handleResize();
        return () => {
            window.removeEventListener("resize", handleResize);
        };
    }, [isCollapsed, location.pathname]);

    const handleSearch = () => {
        const filteredMenuItems = MenuItems()
            .map((item) => {
                if (item.children) {
                    const filteredChildren = item.children.filter((subItem) =>
                        subItem.label
                            .toLowerCase()
                            .includes(searchValue.toLowerCase())
                    );
                    if (filteredChildren.length > 0) {
                        return { ...item, children: filteredChildren };
                    }
                } else if (
                    item.label.toLowerCase().includes(searchValue.toLowerCase())
                ) {
                    return item;
                }
                return null;
            })
            .filter((item) => item !== null);

        return filteredMenuItems;
    };

    const filteredMenuItems = handleSearch();
    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setSearchValue(e.target.value);
    };

    return (
        <DashboardLayoutWrapper>
            <Layout>
                <SidebarContainer
                    collapsible
                    collapsed={isCollapsed}
                    onCollapse={setIsCollapsed}
                    width={350}
                    trigger={null}
                    className="mobile_res_open"
                >
                    <DashboardLogoWrapper>
                        {/*<MbOpenClick>*/}
                        {/*    <button onClick={() => setIsCollapsed((isPrev) => !isPrev)}>&#x2631;</button>*/}
                        {/*</MbOpenClick>*/}
                        <LogoTitleWrapper>
                            {!isCollapsed && (
                                <>
                                    <DashboardLogo src={Logo} alt="logo" />
                                    <DashboardTitle>
                                        Welcome - Ebuh
                                    </DashboardTitle>
                                </>
                            )}
                        </LogoTitleWrapper>

                        {!isCollapsed && (
                            <SearchFormWrapper>
                                {" "}
                                <SearchForm
                                    onChange={handleChange}
                                    value={searchValue}
                                />
                            </SearchFormWrapper>
                        )}
                        {isCollapsed && (
                            <MobileLogo>
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="23"
                                    height="18"
                                    viewBox="0 0 23 18"
                                    fill="none"
                                >
                                    <path
                                        d="M7.22545 15.3653C7.45974 15.3899 7.67628 15.4958 7.83356 15.6629C7.99085 15.83 8.07783 16.0464 8.07783 16.2707C8.07783 16.4951 7.99085 16.7115 7.83356 16.8786C7.67628 17.0456 7.45974 17.1516 7.22545 17.1761C6.3515 17.1758 5.49113 16.9703 4.72057 16.5778C3.95002 16.1854 3.29307 15.6181 2.80793 14.9262C2.32279 14.2344 2.02444 13.4393 1.93932 12.6115C1.85421 11.7837 1.98495 10.9486 2.31996 10.1804C2.65497 9.41215 3.18391 8.73442 3.85991 8.20723C4.53591 7.68005 5.3381 7.3197 6.1954 7.15811C7.0527 6.99653 7.93864 7.03869 8.77473 7.28087C9.61081 7.52305 10.3712 7.95776 10.9886 8.5465C11.2173 8.76449 11.4249 9.00167 11.6088 9.25516C11.7885 8.99863 11.9964 8.76107 12.229 8.5465C12.8464 7.95875 13.6065 7.52494 14.4421 7.28348C15.2777 7.04201 16.1629 7.00034 17.0194 7.16216C17.876 7.32397 18.6774 7.68427 19.3527 8.21116C20.028 8.73806 20.5565 9.4153 20.8912 10.1829C21.2259 10.9505 21.3567 11.7849 21.2718 12.612C21.1869 13.4392 20.8891 14.2337 20.4047 14.9252C19.9203 15.6167 19.2642 16.1839 18.4945 16.5765C17.7248 16.9691 16.8653 17.1751 15.9921 17.1761C15.8584 17.1901 15.7231 17.1772 15.595 17.138C15.4669 17.0989 15.3489 17.0346 15.2488 16.9491C15.1486 16.8637 15.0684 16.7591 15.0136 16.6422C14.9587 16.5253 14.9304 16.3988 14.9304 16.2707C14.9304 16.1427 14.9587 16.0161 15.0136 15.8992C15.0684 15.7823 15.1486 15.6778 15.2488 15.5923C15.3489 15.5069 15.4669 15.4425 15.595 15.4034C15.7231 15.3643 15.8584 15.3513 15.9921 15.3653C16.6634 15.3621 17.3186 15.1699 17.8753 14.8129C18.432 14.456 18.8653 13.9502 19.1206 13.3594C19.3759 12.7685 19.4418 12.119 19.31 11.4925C19.1782 10.8661 18.8546 10.2908 18.38 9.83902C17.9053 9.38727 17.3008 9.07929 16.6426 8.95386C15.9844 8.82842 15.302 8.89115 14.6812 9.13414C14.0603 9.37712 13.529 9.7895 13.1539 10.3193C12.7788 10.8492 12.5769 11.4728 12.5735 12.1117C12.5735 12.3532 12.4727 12.5849 12.2932 12.7558C12.1137 12.9266 11.8703 13.0225 11.6164 13.0225H11.5896C11.3358 13.0225 11.0924 12.9266 10.9129 12.7558C10.7334 12.5849 10.6326 12.3532 10.6326 12.1117C10.6357 11.6875 10.5496 11.267 10.3793 10.8749C10.209 10.4829 9.958 10.1273 9.64106 9.82901C9.24496 9.45326 8.75772 9.17614 8.22238 9.02214C7.68704 8.86815 7.12009 8.84201 6.57162 8.94605C6.02315 9.05008 5.51004 9.28109 5.07764 9.61865C4.64523 9.95621 4.30684 10.3899 4.09235 10.8815C3.87787 11.3731 3.7939 11.9074 3.84786 12.4371C3.90183 12.9669 4.09206 13.4759 4.40176 13.9191C4.71145 14.3623 5.13107 14.7261 5.62355 14.9784C6.11603 15.2306 6.6662 15.3635 7.22545 15.3653Z"
                                        fill="#0BA5EC"
                                    />
                                    <path
                                        d="M11.7441 17.9999C10.5037 16.5571 10.4616 15.127 11.7441 13.7497C13.0246 15.2035 13.0112 16.6226 11.7441 17.9999ZM7.3416 10.8513C7.6278 10.8513 7.90759 10.9321 8.14556 11.0834C8.38352 11.2348 8.56899 11.4499 8.67852 11.7015C8.78805 11.9532 8.8167 12.2301 8.76087 12.4973C8.70503 12.7644 8.56721 13.0098 8.36484 13.2024C8.16246 13.395 7.90462 13.5262 7.62391 13.5794C7.34321 13.6325 7.05225 13.6052 6.78784 13.501C6.52342 13.3967 6.29742 13.2202 6.13841 12.9937C5.9794 12.7672 5.89453 12.501 5.89453 12.2286C5.89453 12.0473 5.93215 11.8677 6.00523 11.7003C6.07831 11.5328 6.18542 11.3807 6.3204 11.2528C6.45538 11.1248 6.61558 11.0235 6.79181 10.9546C6.96804 10.8857 7.15683 10.8506 7.34734 10.8513H7.3416ZM15.8575 10.8513C16.1437 10.8513 16.4235 10.9321 16.6614 11.0834C16.8994 11.2348 17.0849 11.4499 17.1944 11.7015C17.3039 11.9532 17.3326 12.2301 17.2768 12.4973C17.2209 12.7644 17.0831 13.0098 16.8807 13.2024C16.6784 13.395 16.4205 13.5262 16.1398 13.5794C15.8591 13.6325 15.5681 13.6052 15.3037 13.501C15.0393 13.3967 14.8133 13.2202 14.6543 12.9937C14.4953 12.7672 14.4104 12.501 14.4104 12.2286C14.4104 12.0473 14.448 11.8677 14.5211 11.7003C14.5942 11.5328 14.7013 11.3807 14.8363 11.2528C14.9713 11.1248 15.1315 11.0235 15.3077 10.9546C15.4839 10.8857 15.6727 10.8506 15.8632 10.8513H15.8575Z"
                                        fill="#0BA5EC"
                                    />
                                    <path
                                        d="M7.87658 12.1055C8.00961 12.1081 8.13891 12.1479 8.24825 12.2201C8.35758 12.2922 8.4421 12.3935 8.4912 12.5112C8.54029 12.6289 8.55177 12.7578 8.52421 12.8817C8.49664 13.0056 8.43125 13.119 8.33625 13.2077C8.24124 13.2963 8.12084 13.3563 7.99015 13.3801C7.85946 13.4039 7.72429 13.3905 7.60161 13.3414C7.47892 13.2924 7.37417 13.21 7.30051 13.1045C7.22684 12.9991 7.18752 12.8753 7.1875 12.7486C7.18748 12.6631 7.20539 12.5784 7.24018 12.4995C7.27497 12.4207 7.32594 12.3492 7.39011 12.2893C7.45428 12.2294 7.53036 12.1823 7.61389 12.1508C7.69742 12.1192 7.78673 12.1038 7.87658 12.1055ZM1.75141 4.37949C1.89305 4.41704 2.01802 4.49742 2.10744 4.60849C2.19687 4.71957 2.24591 4.85531 2.24717 4.99524C2.24812 5.11525 2.21336 5.23307 2.14691 5.33506C2.08046 5.43706 1.98503 5.51908 1.87167 5.57163C1.7583 5.62417 1.63162 5.64511 1.50628 5.63202C1.38093 5.61893 1.26204 5.57233 1.16335 5.49763C1.06466 5.42293 0.990197 5.32317 0.948575 5.20989C0.906953 5.0966 0.899873 4.97441 0.928148 4.85746C0.956423 4.7405 1.0189 4.63355 1.10836 4.54897C1.19782 4.46439 1.3106 4.40563 1.43367 4.37949V3.68358H1.75141V4.37949ZM1.22695 7.4619L1.41836 6.04458H1.7897L2.07873 7.4619C1.80884 7.72423 1.51789 7.69873 1.24226 7.4619H1.22695ZM5.84379 4.82582L12.1967 6.11198L18.2185 4.57806V6.96456C17.1435 6.54988 15.9645 6.44329 14.8266 6.65787C13.6888 6.87246 12.6416 7.39888 11.8139 8.17238L11.6072 8.36913L11.4005 8.17238C10.2885 7.12656 8.78714 6.54176 7.22387 6.54556C6.76482 6.54658 6.30724 6.59483 5.8591 6.68948V4.82582H5.84379ZM1.32265 3.31741L0 3.04233L10.9832 0L23 3.04233L12.168 5.57456L2.59745 3.6599L12.6619 2.84558L1.32265 3.31741ZM15.2555 12.1055C15.3891 12.1055 15.5198 12.1433 15.6309 12.2139C15.742 12.2846 15.8286 12.385 15.8797 12.5025C15.9309 12.62 15.9443 12.7493 15.9182 12.8741C15.8921 12.9988 15.8278 13.1134 15.7333 13.2033C15.6388 13.2933 15.5184 13.3545 15.3873 13.3793C15.2562 13.4042 15.1204 13.3914 14.9969 13.3428C14.8735 13.2941 14.7679 13.2117 14.6937 13.1059C14.6194 13.0001 14.5798 12.8758 14.5798 12.7486C14.5803 12.6629 14.5987 12.5782 14.6339 12.4993C14.6691 12.4204 14.7204 12.349 14.7849 12.2891C14.8494 12.2293 14.9257 12.1822 15.0094 12.1507C15.0932 12.1192 15.1827 12.1039 15.2727 12.1055H15.2555Z"
                                        fill="#667085"
                                    />
                                </svg>
                            </MobileLogo>
                        )}
                    </DashboardLogoWrapper>
                    <StyledMenu
                        theme="dark"
                        mode="inline"
                        items={filteredMenuItems.map((item) => {
                            if (item && item.children) {
                                return {
                                    key: item.key,
                                    icon: item.icon,
                                    label: item.label,
                                    children: item.children.map((subItem) => ({
                                        key: subItem.key,
                                        label: (
                                            <Link to={subItem.link}>
                                                {subItem.label}
                                            </Link>
                                        ),
                                    })),
                                };
                            } else if (item) {
                                return {
                                    key: item.key,
                                    icon: item.icon,
                                    label: (
                                        <Link to={item.link || ""}>
                                            {item.label}
                                        </Link>
                                    ),
                                };
                            }
                            return null;
                        })}
                    />
                    {!isCollapsed && (
                        <CloseSliderContainerClosed className="closeSliderContainerClosed">
                            <Button
                                type="link"
                                onClick={() => setIsCollapsed(!isCollapsed)}
                            >
                                <svg
                                    style={{
                                        transform: isCollapsed
                                            ? "rotateY(180deg)"
                                            : "none",
                                    }}
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="21"
                                    height="21"
                                    viewBox="0 0 21 21"
                                    fill="none"
                                >
                                    <rect
                                        width="21"
                                        height="21"
                                        fill="#FCFCFD"
                                    />
                                    <path
                                        d="M6.53219 6.24094C6.70606 6.0907 6.96266 6.22575 6.96266 6.46884V14.5329C6.96266 14.7743 6.70775 14.9094 6.53219 14.7608L1.85783 10.7279C1.72447 10.6114 1.72447 10.3886 1.85783 10.2738L6.53219 6.24094ZM9.98267 6.1194H11.3669V14.8807H9.98267V6.1194Z"
                                        fill="#98A2B3"
                                    />
                                </svg>
                            </Button>
                        </CloseSliderContainerClosed>
                    )}
                </SidebarContainer>
                <Layout style={{ background: ThemesColors.iceBlue }}>
                    <Content className="my_own_class">
                        <HeaderOutletWrapper>
                            <Header setIsCollapsed={setIsCollapsed} />
                            <Outlet />
                        </HeaderOutletWrapper>
                    </Content>
                </Layout>
            </Layout>
        </DashboardLayoutWrapper>
    );
};

export default DashboardLayout;
